import { render, staticRenderFns } from "./NestedRing.vue?vue&type=template&id=5dcb746f&scoped=true"
import script from "./NestedRing.vue?vue&type=script&lang=js"
export * from "./NestedRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb746f",
  null
  
)

export default component.exports